import matchHostImg from '../assets/illustrations/onboarding-match-host.png';
import buildPlanImg from '../assets/illustrations/onboarding-build-plan.png';
import keepChattingImg from '../assets/illustrations/onboarding-keep-chatting.png';

export interface OnboardingSlide {
  /** `\n` forces a manual line break instead of relying on text-balance auto-wrap. */
  title: string;
  /** `\n` forces a manual line break instead of relying on text-balance auto-wrap. */
  body: string;
  /** Tabler icon name (no `ti-` prefix), used as a fallback if `image` isn't set —
   *  slide 0 always uses the fetched persona video/photo instead. */
  icon?: string;
  /** Imported illustration src for this slide's media area. */
  image?: string;
}

/**
 * Pre-auth /try tour, shown once before a brand-new anonymous user lands in
 * the Alma chat. Slide 0's media is the active AI persona's video (falling
 * back to its photo) — see OnboardingCarousel's persona fetch, the same
 * ai_personas.video_url mechanism TryIntroModal used.
 */
export const ONBOARDING_SLIDES: OnboardingSlide[] = [
  {
    title: 'Alma gets\nyour taste',
    body: 'A few questions to find your kind of host.\nNot a form. A conversation.',
  },
  {
    title: 'Get matched\nand choose',
    body: "A short list of local hosts, picked for your taste. The one you pick is your host for the trip.",
    icon: 'users',
    image: matchHostImg,
  },
  {
    title: 'Your host\nbuilds the trip',
    body: 'Day-by-day, built around your taste.\nNever a copy-paste itinerary.',
    icon: 'book',
    image: buildPlanImg,
  },
  {
    title: 'Keep talking,\nthe whole trip',
    body: "Plans change. You've got a person, not a chatbot.",
    icon: 'message-circle',
    image: keepChattingImg,
  },
];
